import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import swal from 'sweetalert2'

export default class Route404 extends React.Component {
  componentDidMount() {
    if (process.env.REACT_APP_ENV === 'prod') {
      window.location.href = 'https://adventures.polaris.com'
    }
    swal.fire('Not Found', 'This is not the page you are looking for.', 'warning')
  }

  render() {
    return (
      <div style={{ margin: '0 auto', width: '20rem', paddingTop: '5rem' }}>
        <CircularProgress />
      </div>
    )
  }
}
